/** অ্যাডমিন পেজ এডিটরে সেকশনের নাম ও নতুন সেকশনের ঘর (ST-10)। */
export const pageSectionTypes = {
    hero: "ব্যানার",
    products: "পণ্য",
    imageText: "ছবি ও লেখা",
    text: "লেখা",
    faq: "প্রশ্ন ও উত্তর",
    testimonials: "ক্রেতারা যা বলেন",
    countdown: "কাউন্টডাউন",
    orderForm: "অর্ডার ফর্ম",
    heroSlider: "ব্যানার স্লাইড",
    heroSplit: "দুই ভাগের ব্যানার",
    categoryTiles: "ক্যাটাগরি টাইল",
    flashDeal: "ফ্ল্যাশ ডিল",
    lookbook: "লুকটি কিনুন",
    beforeAfter: "আগে ও পরে",
    featureIcons: "বৈশিষ্ট্যের আইকন",
    marquee: "চলমান লাইন",
    logoWall: "লোগো",
    ugcGrid: "ক্রেতাদের ছবি",
    video: "ভিডিও",
    comparisonTable: "তুলনার টেবিল",
    stats: "সংখ্যা",
    steps: "যেভাবে কাজ করে",
    finder: "পণ্য খুঁজে দিন",
    bundle: "একসাথে কিনুন",
    deliveryInfo: "ডেলিভারির তথ্য",
    richBanner: "ছবির ব্যানার",
    recentlyViewed: "সম্প্রতি দেখা",
    storeLocator: "আমাদের দোকান (শপে দেখানো শাখা)",
    orderAgain: "আবার অর্ডার (শুধু সাইন-ইন করা ক্রেতা)",
    authors: "জনপ্রিয় লেখক",
};
export const pageSectionFields = {
    title: "শিরোনাম",
    subtitle: "উপশিরোনাম",
    videoFileId: "ব্যাকগ্রাউন্ড ভিডিও (MP4)",
    videoHint: "ঐচ্ছিক: ১০ এমবির কম, ১০–২০ সেকেন্ডের শব্দহীন লুপ। শুধু দ্রুত ইন্টারনেটে চলে; নইলে প্রথম স্লাইডের ছবি দেখায়।",
    buttonLabel: "বাটনের লেখা",
    buttonHref: "বাটনের লিংক (/products বা https://…)",
    autoplay: "নিজে থেকে পরের স্লাইডে যাবে",
    slides: "স্লাইড",
    imageSide: "ছবি কোন পাশে",
    left: "বামে",
    right: "ডানে",
    center: "মাঝে",
    chips: "ছোট পয়েন্ট (৪টি পর্যন্ত)",
    style: "ধরন",
    grid: "গ্রিড",
    circles: "গোল",
    large: "বড় টাইল",
    rail: "স্ক্রল করা সারি",
    tiles: "ক্যাটাগরি (খালি রাখলে প্রধান ক্যাটাগরিগুলো)",
    categoryId: "ক্যাটাগরি",
    anyCategory: "যেকোনো ক্যাটাগরি",
    endsAt: "শেষ হবে",
    productIds: "পণ্য",
    limit: "কয়টি",
    imageFileId: "ছবি",
    spots: "ছবিতে থাকা পণ্য",
    x: "আড়াআড়ি (%)",
    y: "নিচে (%)",
    productId: "পণ্য",
    noProduct: "কোনো পণ্য নেই",
    beforeImageFileId: "আগে",
    afterImageFileId: "পরে",
    body: "লেখা",
    items: "আইটেম",
    icon: "আইকন",
    text: "লেখা",
    truck: "ডেলিভারি ট্রাক",
    cash: "টাকা",
    shield: "শিল্ড",
    refresh: "এক্সচেঞ্জ",
    gift: "উপহার",
    phone: "ফোন",
    star: "তারা",
    leaf: "পাতা",
    clock: "ঘড়ি",
    badge: "ব্যাজ",
    speed: "গতি",
    slow: "ধীরে",
    normal: "স্বাভাবিক",
    fast: "দ্রুত",
    imageFileIds: "লোগো",
    caption: "ক্যাপশন",
    url: "YouTube বা Facebook ভিডিওর লিংক",
    posterFileId: "কভার ছবি (ঐচ্ছিক)",
    ours: "আপনার কলাম",
    theirs: "অন্য কলাম",
    rows: "সারি",
    label: "লেবেল",
    value: "সংখ্যা",
    suffix: "সংখ্যার পরে (+, %)",
    question: "প্রশ্ন",
    answers: "উত্তর",
    href: "লিংক (/products?category=… বা /search?q=…)",
    checker: "জেলা অনুযায়ী ডেলিভারি দেখানোর ঘর দেখান",
    align: "লেখার অবস্থান",
    layout: "যেভাবে দেখাবে",
    carousel: "সোয়াইপ সারি",
    menu: "মেনু তালিকা",
    format: "ধরন",
    formatAny: "ছাপা বই ও ডিজিটাল",
    formatPhysical: "শুধু ছাপা বই",
    formatDigital: "শুধু ডিজিটাল (ইবুক)",
    addItem: "যোগ করুন",
    addImage: "ছবি যোগ করুন",
    addProduct: "পণ্য যোগ করুন",
    remove: "সরান",
    realDeadline: "সত্যিকারের শেষ সময় দিন। সময় পার হলে ডিলটি আর দেখাবে না।",
};
//# sourceMappingURL=storefront-sections.js.map